import React from "react";
import { MapPin, Phone, Clock, Mail } from "lucide-react";
import EnquiryForm from "../components/EnquiryForm";
import { CONTACT } from "../lib/constants";

const ContactPage = () => {
  return (
    <div>
      <section className="ve-container pt-20 md:pt-28 pb-12 ve-noise">
        <span className="ve-eyebrow">Contact</span>
        <h1 className="ve-display mt-6 text-[2.6rem] sm:text-4xl md:text-6xl lg:text-7xl max-w-5xl">
          Come to the office,<br />
          <em>or start on WhatsApp.</em>
        </h1>
        <p className="mt-8 max-w-3xl text-base md:text-lg leading-relaxed" style={{ color: "var(--cream-200)" }}>
          We prefer meeting in person — most serious conversations end with a site visit anyway. But if you'd like to start remotely, WhatsApp is the fastest way. The form below also lands directly with the proprietor.
        </p>
      </section>
      <div className="ve-rule" />
      <section className="ve-container py-16 md:py-20 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5 space-y-10">
          <div>
            <div className="ve-label">Office</div>
            <div className="mt-3 flex items-start gap-4 text-base leading-relaxed" style={{ color: "var(--cream-100)" }}>
              <MapPin size={18} style={{ color: "var(--gold-500)", marginTop: 4 }} />
              <address className="not-italic">
                {CONTACT.addressLine1}<br />
                {CONTACT.addressLine2}<br />
                {CONTACT.addressLine3}<br />
                {CONTACT.addressLine4}<br />
                {CONTACT.addressLine5}
              </address>
            </div>
            <a href={CONTACT.mapsDirections} target="_blank" rel="noreferrer" className="mt-5 ve-btn-ghost">
              Get Directions
            </a>
          </div>
          <div className="ve-rule" />
          <div>
            <div className="ve-label">Direct Line</div>
            <div className="mt-3 flex items-center gap-4">
              <Phone size={18} style={{ color: "var(--gold-500)" }} />
              <a href={`tel:${CONTACT.phoneTel}`} className="text-2xl md:text-3xl ve-link-underline" style={{ fontFamily: "Fraunces, serif", color: "var(--cream-100)" }}>
                {CONTACT.phoneDisplay}
              </a>
            </div>
            <div className="mt-3 flex items-center gap-4 text-sm" style={{ color: "var(--cream-200)" }}>
              <Mail size={16} style={{ color: "var(--gold-500)" }} />
              <a href={`mailto:${CONTACT.email}`} className="ve-link-underline">
                {CONTACT.email}
              </a>
            </div>
          </div>
          <div className="ve-rule" />
          <div>
            <div className="ve-label">Hours</div>
            <ul className="mt-3 space-y-2 text-base" style={{ color: "var(--cream-100)" }}>
              {CONTACT.hours.map((h) => (
                <li key={h.day} className="flex items-center gap-4">
                  <Clock size={16} style={{ color: "var(--gold-500)" }} />
                  <span style={{ color: "var(--cream-200)" }}>{h.day}</span>
                  <span className="ml-auto" style={{ color: "var(--cream-100)" }}>{h.time}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="ve-rule" />
          <div className="flex flex-wrap gap-3">
            <a href={CONTACT.whatsappLink} target="_blank" rel="noreferrer" className="ve-btn-whatsapp">
              Chat on WhatsApp
            </a>
            <a href={`tel:${CONTACT.phoneTel}`} className="ve-btn-primary">
              <Phone size={14} /> Call Now
            </a>
          </div>
        </div>
        <div className="lg:col-span-7">
          <div className="ve-card">
            <div className="ve-label">Enquiry Form</div>
            <h3 className="text-3xl md:text-4xl mt-2" style={{ fontFamily: "Fraunces, serif", color: "var(--cream-100)" }}>
              Tell us about your requirement.
            </h3>
            <div className="mt-8">
              <EnquiryForm />
            </div>
          </div>
        </div>
      </section>
      <section className="border-t" style={{ borderColor: "var(--hair)", background: "var(--ink-900)" }}>
        <div className="ve-container py-16">
          <span className="ve-eyebrow">Find the office</span>
          <h2 className="ve-display mt-5 text-3xl md:text-4xl mb-8">
            Venus Atlantis Corporate Park, <em>Prahlad Nagar.</em>
          </h2>
          <div
            className="relative w-full overflow-hidden"
            style={{
              paddingBottom: "46%",
              border: "1px solid var(--hair-strong)",
              background: "var(--ink-800)",
            }}
          >
            <iframe
              title="Vachhraj Estate — Office Location"
              src={CONTACT.mapsEmbed}
              className="absolute inset-0 w-full h-full"
              style={{ border: 0, filter: "grayscale(35%) contrast(1.05)" }}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;